// Types
import type { APICRMPackageItem } from '@/types/api/items/crm/crm-package'

// Plan limits in the order the plan cards list them
export const PACKAGE_LIMITS = [
	'admins_number',
	'couriers_number',
	'developers_number',
	'tables_number',
	'fields_number',
	'options_number',
	'devices_number',
	'service_categories_number',
	'services_number',
	'customer_categories_number',
	'blacklists_number',
	'providers_number',
	'templates_number',
	'inventory_categories_number',
	'inventory_products_number',
	'reminder_number',
	'campaigns_number',
	'reviews_number',
	'google_reviews_number'
] as const

export type PackageLimitKey = (typeof PACKAGE_LIMITS)[number]

// Limits that at least one of the plans includes, so every card can list the same rows and mark what it lacks
export const sharedPackageLimits = (packages: APICRMPackageItem[]): PackageLimitKey[] => PACKAGE_LIMITS.filter(key => packages.some(item => !!item[key]))
